import { render } from "./NotesModal.vue?vue&type=template&id=34e9e9dc&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=34e9e9dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e9e9dc"]])

export default __exports__